import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SearchRequestHistoryItem } from '../../models/searchRequestHistoryItem';
import { SearchHistoryService } from '../../services/search-history.service';
import { KindPage } from '../../enums/kind-page';

@Component({
  selector: 'app-search-history',
  templateUrl: './search-history.component.html'
})
export class SearchHistoryComponent implements OnInit {


  searchHistoryResult: SearchRequestHistoryItem[];
  isHelenaRoute: boolean = false;
  banner:string = "sprayer-sky.webp";
  constructor(private searchHistory: SearchHistoryService,
    private router: Router) { }

  getSearchHistory() {
    this.searchHistoryResult =  this.searchHistory.getAllHistoryItems();
  }

  ngOnInit(): void {
    this.getSearchHistory();
    
    if (this.router.url.includes('helena')) {
      this.isHelenaRoute = true;
    }
   

  }

  selectedRow(index: number) {
 
    var data = this.searchHistory.getHistoryItem(index);
    if (data != undefined) {

      if (this.isHelenaRoute)
      {
        if (data.kind == KindPage.FoliarTankmix) {
          this.router.navigate(['/helena/search-history/' + index]);
        }
        else if (data.kind == KindPage.SeedCoating) {
          this.router.navigate(['/helena/helena-search-seed-treatment/' + index]);
        }
      }
      else {
        if (data.kind == KindPage.FoliarTankmix) {
          this.router.navigate(['/search-history/' + index]);
        }
        else if (data.kind == KindPage.SeedCoating) {
          this.router.navigate(['/search-seed-treatment/' + index]);
        }
      }
     
    }
  }

  clearHistory() {
    this.searchHistory.clearHistory();
    this.getSearchHistory() ;
  }

}
